import { FunctionComponent, PropsWithChildren } from 'react';
import SimpleBar from 'simplebar-react';

export const DetailsSidebarContent: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return (
    <SimpleBar
      style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        gap: '1px',
        overflow: 'auto',
      }}
      autoHide={true}
    >
      {children}
    </SimpleBar>
  );
};
